<template>
  <div class="not-found-wrapper">
    <div class="not-found">
      <p class="error-code">404</p>
      <p class="error-msg">Page not found</p>
      <p class="error-wrong">SOMTHING WENT WRONG</p>
      <p class="error-wrong2">The page you are looking for doesn't exist or another error occurred.<br>
      Go back,or head over to ImGATESM to choose a new direction</p>
      <img src="../assets/img/logo_404.png" alt="logo">
    </div>
  </div>
</template>

<script>
  export default {
  };
</script>

<style lang="scss" scoped>
.not-found-wrapper {
  height: 100%;
  background: url(../assets/img/bg.png) repeat;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .not-found {
    text-align: center;
    // p {
    //   text-align: center;
    // }
    .error-code {
      margin-bottom: 20px;
      font-size: 147px;
      font-weight: 300;
      color: #999999;
      color: white;
    }
    .error-msg {
      margin-bottom: 80px;
      font-size: 36px;
      color: #999999;
    }
    .error-wrong {
      margin-bottom: 15px;
      font-size: 36px;
      color: #FF0066;
      font-weight: 800;
    }
    .error-wrong2 {
      margin-bottom: 30px;
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue